export enum SpeedtestType {
    UPLOAD = 'Upload',
    DOWNLOAD = 'Download',
    UPLOAD_AND_DOWNLOAD = 'Upload and Download',
}
